<template src='./project-document-upload.html'></template>

<script>
import Vue from 'vue'
import VueUploadComponent from 'vue-upload-component'
import { getAccessToken } from '@/utils/cookie'
import { EventBus } from '@/router/bus'

export default {
  components: {
    FileUpload: VueUploadComponent
  },
  props: ['canManageDocuments', 'maximum', 'multiple', 'buttonLabel', 'revisions'],
  data () {
    return {
      data: [],
      projectCode: this.$route.params.projectCode,
      projectDocumentApi: Vue.$config.api_root + '/' + Vue.$apiConfig.projectDocumentPost.replace('{projectCode}', this.$route.params.projectCode),
      projectDocumentHeaders: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      sizeLimit: 1024 * 1024 * 3000,
      filesLimit: 5,
      files: [],
      description: '',
      comment: '',
      documentDialog: false,
      disableButton: false,
      documentTypes: [
        { text: this.$t('projects.document.types.0'), value: 0 },
        { text: this.$t('projects.document.types.3'), value: 3 },
        { text: this.$t('projects.document.types.4'), value: 4 },
        { text: this.$t('projects.document.types.9'), value: 9 },
        { text: this.$t('projects.document.types.10'), value: 10 },
        { text: this.$t('projects.document.types.11'), value: 11 },
        { text: this.$t('projects.document.types.12'), value: 12 },
        { text: this.$t('projects.document.types.5'), value: 5 },
        { text: this.$t('projects.document.types.6'), value: 6 },
        { text: this.$t('projects.document.types.7'), value: 7 },
        { text: this.$t('projects.document.types.19'), value: 19 },
        { text: this.$t('projects.document.types.8'), value: 8 },
        { text: this.$t('projects.document.types.13'), value: 13 },
        { text: this.$t('projects.document.types.14'), value: 14 },
        { text: this.$t('projects.document.types.15'), value: 15 },
        { text: this.$t('projects.document.types.16'), value: 16 },
        { text: this.$t('projects.document.types.17'), value: 17 },
        { text: this.$t('projects.document.types.18'), value: 18 }
      ]
    }
  },
  methods: {
    uploadRevision (revision) {
      this.showLoader(true)
      this.disableButton = true
      revision.description = this.description
      revision.comment = this.comment
      this.$http.post(Vue.$apiConfig.projectDocumentRevisionPost.replace('{projectCode}', this.$route.params.projectCode).replace('{documentId}', this.$route.params.documentId), revision)
        .then(
          response => {
            EventBus.$emit('uploadedDocument')
            this.showLoader(false)
            this.disableButton = false
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.disableButton = false
          }
        )
    },
    openAddDocumentDialog () {
      if (this.$route.params.documentId > 0) {
        this.description = this.revisions[0].description
        this.comment = this.revisions[0].comment
        const file = {
          comment: this.revisions[0].comment,
          description: this.revisions[0].description,
          documentId: this.$route.params.documentId,
          name: this.revisions[0].title + this.revisions[0].extension,
          projectCode: this.projectCode,
          size: this.revisions[0].size,
          previousRevisionFile: true,
          revisionId: this.revisions[0].id
        }
        this.files = [file]
      } else {
        this.description = ''
        this.comment = ''
        this.files = []
      }

      this.documentDialog = true
    },
    inputFile (newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.error && !oldFile.error) {
          // error
          this.handleErrors(newFile)
        }
        if (newFile.success && oldFile.success) {
          // update
          // this.update(newFile, oldFile)
        }
        if (!newFile.active && oldFile.active) {
          // upload
          this.handleUploaded(newFile)
        }
      }
      if (!newFile && oldFile) {
        // remove
        // this.remove(oldFile)
      }
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          this.notifyError(this.$t('projects.document.extensionInvalid'))
          return prevent()
        }
        // Filter php html js file
        if (/\.(html?|php5?|jsx?|bat?|bin?|cmd?|com?|cpl?|exe?|gadget?|inf1?|ins?|inx?|isu?|job?|jse?|lnk?|msc?|msi?|msp?|mst?|paf?|pif?|ps1?|reg?|rgs?|scr?|sct?|shb?|shs?|u3p?|vb?|vbe?|vbs?|vbscript?|ws?|wsf?|wsh?)$/i.test(newFile.name)) {
          this.notifyError(this.$t('projects.document.extensionInvalid'))
          return prevent()
        }

        // Filter size limit
        if (newFile.size >= this.sizeLimit) {
          this.notifyError(this.$t('projects.document.sizeLimitReached') + ' ' + (this.sizeLimit / 1024 / 1024).toFixed(2) + ' MB')
          return prevent()
        }

        if ((this.filesCount + 1) > this.activeFilesLimit) {
          this.notifyError(this.$t('projects.document.countLimitReached') + this.activeFilesLimit)
          return prevent()
        }
        this.initializeAddedFile(newFile)
      }
    },
    validateBeforeUpload () {
      if (this.$route.params.documentId > 0 && this.files[0].previousRevisionFile) {
        this.uploadRevision(this.files[0])
      } else {
        this.files.forEach(file => {
          file.documentType = file.documentType ?? 0
          const data = {
            data: file,
            title: file.title,
            description: this.description,
            comment: this.comment,
            projectCode: this.projectCode,
            headers: { Authorization: 'Bearer ' + getAccessToken() }
          }
          file.description = this.description
          file.comment = this.comment
          this.$refs.upload.update(file.id, data)
        })
      }

      this.showLoader(true)
      this.disableButton = true
      this.$refs.upload.active = true
      this.documentDialog = false
    },
    initializeAddedFile (newFile) {
      newFile.extension = this.getExtensionFromFilename(newFile.name)
      newFile.title = this.getNameFromFilename(newFile.name, newFile.extension)
      newFile.description = this.description
      newFile.comment = this.comment
      newFile.documentType = this.documentType
      newFile.projectCode = this.projectCode
      newFile.documentId = this.$route.params.documentId
      newFile.blob = URL.createObjectURL(newFile.file)
    },
    handleErrors (newFile) {
      if (newFile.xhr) {
        console.log(newFile)
        this.formatDocumentErrorResponse(newFile.xhr)
      }
      this.showLoader(false)
    },
    getExtensionFromFilename (filename) {
      return filename.substr(filename.lastIndexOf('.'))
    },
    getNameFromFilename (filename, extension) {
      return filename.replace(extension, '')
    },
    handleUploaded () {
      EventBus.$emit('uploadedDocument', true)
      this.showLoader(false)
      this.disableButton = false
    },
    showLoader (loader) {
      EventBus.$emit('projectLoader', loader)
    },
    removeDocument (documentIndex) {
      this.files.splice(documentIndex, 1)
    }
  }
}
</script>

<style lang="scss" type="text/scss">
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}
.file-uploads {
  color: var(--v-anchor-base) !important;
  caret-color: var(--v-anchor-base) !important;
  padding-top: 10px !important;
}
.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}
.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}
.v-dialog--documents {
  .v-dialog {
    overflow: visible !important;
  }
  .v-list-item {
    background-color: #fafafa !important;
    border-radius: 5px !important;
    border: 1px solid #dadada !important;
  }
  ::-webkit-scrollbar {
    width: 20px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
}
</style>
